import PeopleIcon from "@mui/icons-material/People";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "crm", spoke: "crm", title: "CRM", icon: PeopleIcon, order: 20, entries: [
  { label: "Customers", to: "/app/crm/customers", permission: "crm.customer.view" },
  { label: "Pipeline", to: "/app/crm/pipeline", permission: "crm.opportunity.view" },
  { label: "Opportunities", to: "/app/crm/opportunities", permission: "crm.opportunity.view" },
  { label: "My activities", to: "/app/crm/activities", permission: "crm.activity.view" },
  { label: "Territories", to: "/app/masterdata/territories", permission: "crm.territory.view" },
  { label: "Pipeline stages", to: "/app/masterdata/pipeline-stages", permission: "crm.pipeline.view" },
] });
